import { CoreLayoutView, ORIENTATION_ENUM } from '@core/widgets';
import { TItem, TWidgetProps } from '@libs/types';
import React from 'react';
import { TConsumerItem, TConsumerListData } from '../../../types/data';
import { TListOption } from '../../../types/options';
import { SelectorExtraView } from '../../UI/Row/SelectorExtraView';

type TCurrencyListViewProps = {
    widget?: TWidgetProps<TConsumerListData, TListOption>['widget'];
    isHidden?: boolean;
    items: Array<TConsumerItem>;
    onSelectItem: (uid: string, item: TItem) => void;
};

const CurrencyListView = ({ widget, isHidden, items, onSelectItem }: TCurrencyListViewProps) => {
    if (!Array.isArray(items) || items.length === 0) {
        return null;
    }

    const parentStyleNames = [widget?.options?.style].filter(Boolean) as string[];

    return (
        <CoreLayoutView
            widget={widget}
            uid={widget?.uid}
            isHide={isHidden}
            styleName="currencyListLayout"
            parentStyleNames={parentStyleNames}
            styleProps={{ orientation: ORIENTATION_ENUM.VERTICAL, margin: widget?.options?.margin }}
        >
            {items.map((item) => {
                const itemKey = item.id ?? (item.value as string);
                return (
                    <SelectorExtraView
                        key={itemKey}
                        uid={`${widget?.uid ?? ''}-${itemKey}`}
                        title={item.title}
                        subtitle={item.subtitle}
                        metaText={item.statusText ?? item.metaText}
                        metaVariant={item.metaVariant}
                        metaHierarchy={item.metaHierarchy}
                        iconName={item.iconName}
                        defaultIconName={item.defaultIconName}
                        flagIcon={item.flagName ?? item.icon}
                        flagIconSmall={item.flagIconSmall}
                        avatar={item.avatar}
                        iconHierarchy={item.iconHierarchy}
                        iconVariant={item.iconVariant ?? 'circle'}
                        isSelected={item.selected}
                        isDisabled={item.isDisabled}
                        parentStyleNames={parentStyleNames}
                        handleClick={() => {
                            if (!item.isDisabled) {
                                onSelectItem?.(widget?.uid ?? '', item);
                            }
                        }}
                    />
                );
            })}
        </CoreLayoutView>
    );
};

export { CurrencyListView };
